import { forwardRef, useContext } from 'react';
import { CompactPagination } from '../../../../navigation/compact-pagination';
import { CompactPaginationProps } from '../../types';
import { Context } from '../../services/context';
import { FALLBACK_SLIDE_COUNT } from '../../const';
import { defaultItemAriaLabelFormatter } from './model';

export const Entry = forwardRef<HTMLElement, CompactPaginationProps>(
  function Component(
    { itemAriaLabelFormatter = defaultItemAriaLabelFormatter, ...props },
    forwardedRef
  ) {
    const { slideCount, currentSlideIndex, setCurrentSlideIndex, scrollTo } =
      useContext(Context);

    if (slideCount === FALLBACK_SLIDE_COUNT) {
      return null;
    }

    const createClickHandler = (slideIndex: number) => () => {
      setCurrentSlideIndex(slideIndex);
      scrollTo(slideIndex);
    };

    return (
      <CompactPagination {...props} ref={forwardedRef}>
        {Array.from({ length: slideCount }).map((_, slideIndex) => (
          <CompactPagination.Item
            key={slideIndex}
            aria-label={itemAriaLabelFormatter(slideIndex, slideCount)}
            isSelected={slideIndex === currentSlideIndex}
            onClick={createClickHandler(slideIndex)}
          />
        ))}
      </CompactPagination>
    );
  }
);
